import React from 'react';
import { diceTypes } from './WarhammerResult'
import { removeOppositeOrAddVal, getAllRolledFaces } from '../resultHelpers';

var summarizeRoll = (result) => {

  var allRolledFaces = getAllRolledFaces(result, diceTypes);

  var sucessChallenge = [],
    boonBane = [],
    remaining = [];

  allRolledFaces.forEach(face => {
    switch (face) {
      case 'S': removeOppositeOrAddVal(sucessChallenge, 'H', face); break;
      case 'H': removeOppositeOrAddVal(sucessChallenge, 'S', face); break;

      // Righteous Success, add success, and show it
      case 'R':
      sucessChallenge.push('R');
      removeOppositeOrAddVal(sucessChallenge, 'H', 'S');
      break;

      case 'B': removeOppositeOrAddVal(boonBane, 'O', face); break;
      case 'O': removeOppositeOrAddVal(boonBane, 'B', face); break;

      // Everything else just goes into the pool
      default: remaining.push(face);
    }
  })

  return {
    sucessChallenge,
    boonBane,
    remaining,
  }
}

var WarhammerResultSummary = ({ result }) => {
  var summary = summarizeRoll(result);

  var faceMap = {
    B: 'bane', C: 'comet', D: 'delay', E: 'exertion',
    H: 'challenge', O: 'boon', R: 'righteous',
    S: 'success', T: 'star',
  }

  var fKey = 0;
  var faceImgFn = face => <img height="21" key={fKey++} alt={faceMap[face]} className="summaryDiceFace" src={`/diceImages/warhammer/summaryFaces/${faceMap[face]}.png`} />

  return (
    <div>
      <span title={summary.sucessChallenge.length}>{summary.sucessChallenge.map(faceImgFn)}</span>
      <span title={summary.boonBane.length}>{summary.boonBane.map(faceImgFn)}</span>
      <span>{summary.remaining.map(faceImgFn)}</span>
    </div>
  )
}

export { summarizeRoll };
export default WarhammerResultSummary;


// WEBPACK FOOTER //
// ./src/RollResults/Warhammer/WarhammerResultSummary.js